import React from "react"
import {
  View,
  Text,
  Window,
  Image,
  Touchable,
  CardNavigation,
} from "react-ame-components"

export class SellerPerfilExample extends React.Component {
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginVertical="big">
          <View
            width="500px"
            backgroundColor="neutral-100"
            padding="medium"
            borderRadius="small">
            <View justify="end">
              <Touchable onClick={() => alert("Fechar")}>
                <Image
                  icon="close"
                  colorIcon="neutral-500"
                />
              </Touchable>
            </View>
            <View marginTop="medium">
              <Text
                fontWeight="bold"
                fontSize="small"
                lineHeight="medium">
                Perfil
              </Text>
            </View>
            <View
              align="center"
              justify="center"
              direction="column">
              <Image
                src="https://www.w3schools.com/howto/img_avatar.png"
                width="120px"
                height="120px"
                borderRadius="medium"
              />
              <View
                marginTop="nano"
                display="flex">
                <Text
                  fontSize="nano"
                  color="neutral-500"
                  lineHeight="medium"
                  textAlign="center">
                  Criado em 29/01/21
                </Text>
              </View>
            </View>
            <View>
              <View
                direction="column"
                justify="start"
                marginTop="medium">
                <Text
                  fontSize="nano"
                  fontWeight="bold"
                  lineHeight="medium">
                  Nome
                </Text>
                <Text
                  fontSize="extra-small"
                  lineHeight="medium">
                  Carlos H. de Souza
                </Text>
                <Text
                  fontSize="nano"
                  fontWeight="bold"
                  lineHeight="medium">
                  Usuário
                </Text>
                <Text
                  fontSize="extra-small"
                  lineHeight="medium">
                  carlos.souza
                </Text>
                <Text
                  fontSize="nano"
                  fontWeight="bold"
                  lineHeight="medium">
                  Senha
                </Text>
                <View
                  direction="row"
                  align="center"
                  justify="between">
                  <Text
                    fontSize="extra-small"
                    lineHeight="medium">
                    ********
                  </Text>
                  <Touchable onClick={() => window.alert("Alterar Senha")}>
                    <Text
                      fontSize="nano"
                      lineHeight="medium"
                      color="primary"
                      fontWeight="bold"
                      textAlign="right">
                      Alterar
                    </Text>
                  </Touchable>
                </View>
              </View>
              <View
                direction="column"
                justify="start"
                marginTop="medium">
                <Text
                  fontSize="nano"
                  fontWeight="bold"
                  lineHeight="medium">
                  Permissões
                </Text>
                <Text
                  fontSize="extra-small"
                  lineHeight="medium">
                  Vendedor
                </Text>
              </View>
            </View>
            <View marginTop="medium">
              <Text
                fontSize="nano"
                fontWeight="bold"
                lineHeight="medium">
                Líder direto
              </Text>
              <CardNavigation
                leftImage={"https://www.w3schools.com/howto/img_avatar.png"}
                width="500"
                title="Claudio Vieira"
                description="Gerente de conta"
                onClick={() => console.log("Lider")}
              />
            </View>
            <View marginTop="medium">
              <View
                direction="column"
                marginBottom="quark">
                <Text
                  fontSize="nano"
                  fontWeight="bold"
                  lineHeight="medium">
                  Grupos
                </Text>
                <Text
                  fontSize="quark"
                  lineHeight="medium"
                  color="neutral-500">
                  Grupos que faz parte
                </Text>
              </View>
              <CardNavigation
                width="500"
                title="Postos BR Itaquaquecetuba"
                description="vendedor"
                rightIcon="right-next"
                onClick={() => console.log("Posto BR")}
              />
              <CardNavigation
                width="500"
                title="Postos BR Itaquaquecetuba"
                description="vendedor"
                rightIcon="right-next"
                onClick={() => console.log("Posto BR")}
              />
            </View>
            <View
              display="flex"
              justify="center"
              marginVertical="medium">
              <Touchable onClick={() => window.alert("Ver Todos")}>
                <Text
                  fontSize="nano"
                  lineHeight="medium"
                  color="primary">
                  Ver todos
                </Text>
              </Touchable>
            </View>
            <View
              direction="row"
              flexWrap>
              <View
                direction="column"
                justify="center"
                align="center"
                borderRadius="medium"
                shadow="level-2"
                marginRight="nano"
                padding="nano">
                <Image
                  icon="padlock-lock-outline"
                  width="35px"
                />
                <Text
                  fontSize="nano"
                  lineHeight="large"
                  color="neutral-700">
                  Privacidade
                </Text>
              </View>
              <View
                direction="column"
                justify="center"
                align="center"
                borderRadius="medium"
                padding="nano"
                shadow="level-2">
                <Image
                  icon="help-outline"
                  width="35px"
                />
                <Text
                  fontSize="nano"
                  lineHeight="large"
                  color="neutral-700">
                  Central de ajuda
                </Text>
              </View>
            </View>
            <View
              display="flex"
              justify="center"
              marginTop="extra-small">
              <Text
                fontSize="nano"
                lineHeight="large"
                color="primary">
                Sair da conta
              </Text>
            </View>
          </View>
        </View>
      </Window>
    )
  }
}
